//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Form, Header, Button, ButtonStyle, Checkbox } from '@cmp/common';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { withAuthUser } from '@helpers/auth';
import { ScreenSet, showScreenSet } from '@helpers/gigya';
import { StoreConfigContext } from '@helpers/storeConfigContext';
//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
import { removeEmptyAddresses } from '@helpers/gigya';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class RegistrationComplete extends React.Component {
  componentDidMount() {
    const { __authUser } = this.props;
    const {
      storeConfig: { language },
    } = this.context;

    showScreenSet(
      language,
      {
        ...ScreenSet.SignUp,
        events: {
          onAfterScreenLoad: (e) => {
            document
              .getElementById('signup-container')
              .querySelectorAll('.gigya-input-text,.gigya-input-password')
              .forEach((nodeInput) => {
                nodeInput.addEventListener('keyup', (event) => {
                  window.interactiveLabel(event);
                });
              });
            removeEmptyAddresses(e);
          },
        },
      },
      'signup-container',
      {
        regToken: __authUser && __authUser.regToken,
      }
    );
  }

  render() {
    const { history, t } = this.props;
    const componentClasses = classNames(styles.RegistrationComplete);

    return (
      <div className={componentClasses}>
        <Helmet>
          <title>{t('landing_CompleteYourRegistration')}</title>
        </Helmet>

        <Header />
        <div className={styles.FormBlock}>
          <Form
            className={styles.Form}
            title={t('landing_YourInformation')}
            id="signup-container"
          />
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withAuthUser(withTranslation()(RegistrationComplete));
RegistrationComplete.contextType = StoreConfigContext;
